(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sub-categories"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
  const swiperSubCollection = document.querySelector('.swiper-subcategories');
  if (swiperSubCollection) {
    const swiper = new Swiper(swiperSubCollection, {
      slidesPerView: 'auto',
      spaceBetween: 15
    });
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sub-collections"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
  const swiperSubCollection = document.querySelector('.swiper-subcollection');
  if (swiperSubCollection) {
    const swiper = new Swiper(swiperSubCollection, {
      slidesPerView: 'auto',
      spaceBetween: 15
    });
  }
});
  } catch(e) { console.error(e); }
})();

})();
